<int-integrators-details
    [integrationName]="integrationName"
    [integrationType]="integrationType"
    [creating]="creating"
    [user]="user"
    [invites]="invites"
></int-integrators-details>
<div mat-dialog-content>
  <div class="radio-container" *ngIf="isAdmin && creating">
    <label>Integration Type</label>
    <mat-radio-group [(ngModel)]="intType">
      <mat-radio-button value="oauth">OAuth</mat-radio-button>
      <mat-radio-button value="mcc">MCC</mat-radio-button>
    </mat-radio-group>
  </div>

  <div *ngIf="creating" class="int-text-container">
    {{ description }}
  </div>

  <form
      *ngIf="isAdmin && intType === 'mcc' && creating"
      [fxShow]="!data.customerId"
      (keydown.enter)="doNotSubmit($event)"
      #gaForm="ngForm"
      (ngSubmit)="saveMcc()"
      fxLayout="column"
  >
    <div fxLayout="row">
      <mat-form-field>
        <input
            matInput
            #name="ngModel"
            placeholder="Google Ads Customer Id"
            [(ngModel)]="customerId"
            autocomplete="googleAdsId"
            name="googleAdsId"
            mask="000-000-0000"
            [showMaskTyped]="true"
            required
        />
        <mat-error *ngIf="name.invalid && (name.dirty || name.touched)">
          <div *ngIf="name.errors.required">Google Ads ID is required</div>
          <div *ngIf="name.errors.pattern">Enter a valid Google Ads ID</div>
        </mat-error>
      </mat-form-field>
    </div>
    <div fxLayout="row">
      <mat-checkbox [(ngModel)]="useCallExt" name="useCallExt">
        I'm using
        <a href="https://support.google.com/google-ads/answer/2453991" target="_blank" class="mat-text-primary"
        >Google Ads Call Extensions</a
        ></mat-checkbox
      >
    </div>
    <div class="int-text-container">
      To connect your Google Ads account enter your Google Ads Customer ID and we will send a request email to the
      Admin(s) for access.
    </div>
  </form>

  <div fxLayout="row" fxFlexAlign="center">
    <div
        (click)="onClick($event)"
        *ngIf="creating && !googleAccountTree.length && !loading && intType === 'oauth'"
        class="google-btn"
    >
      <div class="google-icon-wrapper">
        <img class="google-icon-svg" src="../../assets/image/google-signin-btn.svg"/>
      </div>
      <p class="btn-text"><b>Sign in with Google</b></p>
    </div>
  </div>

  <mat-progress-spinner *ngIf="loading" diameter="40" mode="indeterminate"></mat-progress-spinner>

  <div *ngIf="creating && intType === 'oauth'" class="int-text-container">
    Click the sign in with google button to authorize Advocado, then select the account you would like to use. If your
    account is managed by an MCC, be sure to select the lowest possible child account, not the manager account.
  </div>

  <div *ngIf="creating && googleAccountTree && googleAccountTree.length" class="tree-box">
    <mat-tree [dataSource]="googleAccountSource" [treeControl]="accountTreeControl" class="account-tree">
      <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle>
        <mat-button (click)="save(node.account)">{{node.account.name?node.account.name:node.account.customerId}}</mat-button>
      </mat-tree-node>

      <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
        <div class="mat-tree-node">
          <button mat-icon-button [attr.aria-label]="'Toggle ' + node.account.name" matTreeNodeToggle>
            <mat-icon class="mat-icon-rtl-mirror">
              {{accountTreeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          {{node.account.name? node.account.name: node.account.customerId}}
          <div *ngIf="accountTreeControl.isExpanded(node)" role="group">
            <ng-container matTreeNodeOutlet></ng-container>
          </div>
          <mat-progress-bar *ngIf="node.isLoading"
                            mode="indeterminate"
                            class="tree-progress-bar"></mat-progress-bar>
        </div>
      </mat-nested-tree-node>
    </mat-tree>
  </div>

  <mat-error *ngIf="creating && noAccounts"
  >No Google Ads Accounts found! Try using a different Google Account.
  </mat-error
  >

  <div *ngIf="isAdmin && invites.length > 0">
    <button mat-stroked-button color="primary" (click)="onViewInvitesClick()">VIEW ALL INVITES</button>
  </div>

  <div *ngIf="!creating" fxLayout="row" fxLayoutAlign="start center" class="int-add-container">
    <button mat-stroked-button color="primary" (click)="addAnother($event)">
      <mat-icon>add</mat-icon>
      <span class="center-text">ADD ANOTHER ACCOUNT</span>
    </button>
  </div>

  <div *ngIf="!noAccounts && !creating">
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="!showAccounts">
      <mat-icon>expand_more</mat-icon>
      <span>SHOW CONNECTED ACCOUNTS</span>
    </button>
    <button mat-stroked-button class="toggle-btn" (click)="toggleShowAccounts()" *ngIf="showAccounts">
      <mat-icon>expand_less</mat-icon>
      <span>HIDE CONNECTED ACCOUNTS</span>
    </button>
  </div>

  <div *ngIf="!creating" [hidden]="!showAccounts">
    <h4 *ngIf="existingIntegrations.length > 0" class="mr-4">Connected Accounts</h4>
    <div *ngFor="let int of existingIntegrations">Account Name: {{ int.friendlyName }}</div>
  </div>
</div>

<div mat-dialog-actions align="end">
  <div fxLayout="row" fxLayoutAlign="end end">
    <button mat-button mat-dialog-close>CANCEL</button>
    <button
        [disabled]="creatingMcc"
        *ngIf="isAdmin && intType === 'mcc'"
        mat-raised-button
        color="primary"
        (click)="saveMcc()"
        [disabled]="saving || canSubmit()"
    >
      CONNECT
    </button>
  </div>
</div>
